import React from "react";
import ReactDOM from "react-dom/client";
import FormVal from "./FormVal";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <FormVal/>
  </React.StrictMode>
);
